<template>
<div>
    <Breadcrumbs main="Procurement" submain="Create" title="Bill Create" />
    <div class="container-fluid">

        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Vendor</label>

                                        <v-select class="custom-vue-select" disabled :options="vendors" :get-option-label="vendorLabel" :reduce="vendor => vendor.user.id" v-model="bill.vendor" @input="getVendor" placeholder="Select a vendor"></v-select>
                                    </div>
                                </div>

                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Project</label>
                                        <v-select class="custom-vue-select" disabled :options="projects" label="title" :reduce="project => project.id" v-model="bill.project" placeholder="Select a project"></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Email</label>
                                        <input class="form-control" type="text" placeholder="Enter email address" v-model="bill.email">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Currency</label>
                                        <select class="form-control digits" v-model="bill.currency">
                                            <option v-for="(currency, index) in currencies" :key="index">{{ currency }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Vendor Address</label>
                                        <input class="form-control" type="text" placeholder="Enter vendor address" v-model="bill.vendor_address">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Billing Address</label>
                                        <input class="form-control" type="text" placeholder="Enter billing address" v-model="bill.billing_address">
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Bill Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="bill.bill_date"></datepicker>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Due Date</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" v-model="bill.due_date"></datepicker>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Upload Attachment</label>
                                        <b-form-file v-model="bill.bill_attachment" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..." @change="uploadFile"></b-form-file>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Items <span style="color: red;">*</span></label>
                                        <div class="table-container">
                                            <div class="table-responsive datatable-vue">
                                                <b-table show-empty stacked="md"  :items="bill.details" :fields="tableFields">
                                                    <!-- <template #cell(id)="row">
                                                        {{ row.index+1 }}
                                                    </template> -->

                                                    <template #cell(name)="row">
                                                        <div v-if="row.item.item_name">
                                                            <input class="form-control" type="text" placeholder="Enter label name" disabled v-model="row.item.item_name">
                                                        </div>                    
                                                    </template>


                                                    <template #cell(quantity)="row">
                                                        <div v-if="row.item.quantity_billed">
                                                            <input  class="form-control" type="number" placeholder="Enter item quantity" disabled v-model="row.item.quantity_billed">
                                                        </div>
                                                    </template>

                                                    <template #cell(unit)="row">                                                  
                                                        <div v-if="row.item.unit_price_billed">
                                                            <input class="form-control" type="number" placeholder="0" disabled v-model="row.item.unit_price_billed" >
                                                        </div>
                                                    </template>

                                                   
                                                </b-table>
                                            </div>

                                           
                                        </div>
                                       
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-4"></div>
                                <div class="col-sm-8">
                                    <!-- Total -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Total</label>
                                        <input class="form-control" type="number" placeholder="Enter total amount" disabled v-model="total" />
                                    </div>

                                    <!-- Vat -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Vat (%)</label>
                                        <div class="d-flex w-100 flex-lg-nowrap flex-wrap" style="gap:16px">

                                            <div class="w-100">
                                                <select class="form-control digits" v-model="bill.vat_type">
                                                    <option disabled value="">Select Vat Type</option>
                                                    <option v-for="(type, index) in vat_type" :key="index" :value="type.value">{{ type.title }}</option>
                                                </select>
                                                <small class="text-danger" v-if="errors.vat_type">{{ errors.vat_type }}</small>
                                            </div>
                                            <div class="w-100">
                                                <input class="form-control" type="number" placeholder="Enter vat (%)" min="0" v-model="bill.vat" />
                                                <small class="text-danger" v-if="errors.vat">{{ errors.vat }}</small>
                                            </div>
                                            <input class="form-control" type="number" placeholder="Vat Amount" v-model="vatAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Tax -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Tax (%)</label>
                                        <div class="d-flex w-100 flex-lg-nowrap flex-wrap" style="gap:16px">
                                            <div class="w-100">
                                                <select class="form-control digits" v-model="bill.tax_type">
                                                    <option disabled value="">Select Tax Type</option>
                                                    <option v-for="(type, index) in vat_type" :key="index" :value="type.value">{{ type.title }}</option>
                                                </select>
                                                <small class="text-danger" v-if="errors.tax_type">{{ errors.tax_type }}</small>
                                            </div>
                                            <div class="w-100">
                                                <input class="form-control" type="number" placeholder="Enter tax (%)" min="0" v-model="bill.tax" />
                                                <small class="text-danger" v-if="errors.tax">{{ errors.tax }}</small>

                                            </div>
                                            <input class="form-control" type="number" placeholder="Tax Amount" v-model="taxAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Discount -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Discount (%)</label>
                                        <div class="d-flex w-100" style="gap:16px">
                                            <input class="form-control" type="number" placeholder="Enter discount (%)" v-model="bill.discount" />
                                            <input class="form-control" type="number" placeholder="Discount Amount" v-model="discountAmount" disabled />
                                        </div>
                                    </div>

                                    <!-- Grand Total -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">Grand Total ({{ bill.currency ? bill.currency : "BDT" }})</label>
                                        <input class="form-control" type="number" placeholder="Enter grand total" disabled v-model="subtotal" />
                                    </div>

                                    <!-- In Words -->
                                    <div class="form-group" style="display: flex; gap: 25px; align-items: center;">
                                        <label style="margin-top: 8px; font-weight: 500; width: 120px;">In Words</label>
                                        <input class="form-control" type="text" placeholder="Enter grand total in words" v-model="bill.in_words" />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Remarks</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter remarks..." rows="2" v-model="bill.remarks"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="validateType" class="btn btn-success mr-3">Create</button>
                                        <router-link to="/procurement/bill/list">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    computed
} from "vue";
import ItemTable from "../items-table/item-table.vue";
import moment from "moment";
import Multiselect from 'vue-multiselect';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import {
    toWords
} from 'number-to-words'
export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        ItemTable,
        Multiselect,
        'v-select': vSelect
    },

    data() {
        return {
            discountAmount: computed(() => {
                if (this.total !== 0) {
                    const discount = this.bill.discount || 0;
                    let total = this.total + discount * (this.total / 100)
                    let gtotal = total - this.total
                    return Math.round((gtotal + Number.EPSILON) * 100) / 100;
                }
                return 0;
            }),

            basePrice: computed(() => {
                if (!this.total || !this.bill ?.vat_type || !this.bill ?.tax_type) return 0;

                const total = Number(this.total);
                const vat = Number(this.bill.vat || 0);
                const tax = Number(this.bill.tax || 0);

                if (this.bill.vat_type === 'inclusive' && this.bill.tax_type === 'inclusive') {
                    const divisor = 1 + (vat + tax) / 100;
                    const base = total / divisor;
                    return Math.round((base + Number.EPSILON) * 100) / 100;
                }

                let divisor = 1;
                if (this.bill.vat_type === 'inclusive') {
                    divisor += vat / 100;
                }
                if (this.bill.tax_type === 'inclusive') {
                    divisor += tax / 100;
                }

                const base = total / divisor;
                return Math.round((base + Number.EPSILON) * 100) / 100;
            }),

            taxAmount: computed(() => {
                if (this.bill?.tax && this.bill ?.tax_type && this?.total) {
                    const vat = Number(this.bill.tax);
                    return Math.round((this.basePrice * vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),

            vatAmount: computed(() => {
                if (this.bill ?.vat && this.bill ?.vat_type && this.total) {
                    const vat = Number(this.bill.vat);
                    return Math.round((this.basePrice * vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),

            bill: {
                purchase_order: this.$route.query.po,
                grns: [],
                email: '',
                project: null,
                currency: 'BDT',
                vendor_address: '',
                vendor: '',
                bill_attachment: null,
                billing_address: '',
                bill_date: null,
                due_date: null,
                details: [],
                tax: null,
                vat: null,
                vat_type: '',
                tax_type: '',
                discount: null,
                
                // total: computed(() => {
                //   let total = 0;

                //         if (Array.isArray(this.bill.details)) {
                //             this.bill.details.forEach((item) => {
                //                 total += Number(item.total || 0);
                //             });
                //         }
                //         return total;
                // }),
                // subtotal: computed(() => {
                //     if (!this.bill ?.total || !this.bill ?.vat_type || !this.bill ?.tax_type) return 0;

                //     const total = Number(this.bill.total);
                //     const discount = Number(this.bill.discount || 0);

                //     if (this.bill.vat_type === 'inclusive' && this.bill.tax_type === 'inclusive') {
                //         const discounted = total - (total * discount / 100);
                //         return Math.round((discounted + Number.EPSILON) * 100) / 100;
                //     }
                //     let calculated = total;

                //     if (this.bill.vat_type === 'exclusive') {
                //         calculated += this.vatAmount;
                //     }

                //     if (this.bill.tax_type === 'exclusive') {
                //         calculated += this.taxAmount;
                //     }
                //     const discounted = calculated - (calculated * discount / 100);
                //     return Math.round((discounted + Number.EPSILON) * 100) / 100;
                // }),

                in_words: '',
                remarks: ''
            },

            category: [],

            item: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                category: [],
                company: '',
                address: '',
                status: true
            },

            currencies: ['BDT', 'USD', 'EUR'],

            vat_type: [{
                    id: 1,
                    value: "inclusive",
                    title: "Inclusive",
                },
                {
                    id: 2,
                    value: "exclusive",
                    title: "Exclusive",
                }
            ],
            errors: {
                vat_type: '',
                tax_type: '',
                vat: '',
                tax: '',
            },
            tableFields: [
                {
                    key: 'name',
                    label: 'Item',
                    sortable: false
                },
                {
                    key: 'quantity',
                    label: 'Quantity Billed',
                    sortable: false
                },
                {
                    key: 'unit',
                    label: 'Unit Price',
                    sortable: false
                },
                {
                    key: 'total',
                    label: 'Total',
                    sortable: false
                },
                
            ],
        };
    },
    watch: {
        'subtotal'(val) {
            if (!val) {
                this.bill.in_words = ''
                return
            }
            const text = toWords(val)
            this.bill.in_words = text.replace(/\b\w/g, c => c.toUpperCase())
        },
        poData(newVal, oldVal) {
            this.bill.email = newVal.email
            this.bill.currency = newVal.currency
            this.bill.vendor_address = newVal.vendor_address
            this.bill.billing_address = newVal.billing_address
            this.bill.vendor = newVal.vendor ?.id
            this.bill.project = newVal.project ?.id
            this.bill.due_date = newVal.due_date
            this.bill.vat_type = newVal.vat_type
            this.bill.tax_type = newVal.tax_type
            this.bill.vat = newVal.vat
            this.bill.tax = newVal.tax
            this.bill.discount = newVal.discount

        },
        prefill_bill(newVal, oldVal) {
            this.bill.details = newVal.map(item => ({
                grn_item: item.grn_item,
                po_item: item.po_item,
                item_name: item.item_name,
                quantity_billed: item.quantity_billed,
                unit_price_billed: item.unit_price_billed,
                total: item.quantity_billed * item.unit_price_billed
            }))
        }

    },

    computed: {
        ...mapState({
            items: state => state.item.items,
            projects: state => state.project.project,
            vendors: state => state.vendor.vendor_without_pg,
            prefill_bill: state => state.bill.prefilled_bill_detail,
            poData: (state) => state.purchase_order.purchase_order_detail,
        }),
        total() {
            let total = 0;

            if (Array.isArray(this.bill.details)) {
                this.bill.details.forEach((item) => {
                    total += Number(item.total || 0);
                });
            }

            return total;
        },
        subtotal() {
                if (!this.total || !this.bill.vat_type || !this.bill.tax_type) {
                    return 0;
                }

                const total = Number(this.total);
                const discount = Number(this.bill.discount || 0);

                if (
                    this.bill.vat_type === 'inclusive' &&
                    this.bill.tax_type === 'inclusive'
                ) {
                    const discounted = total - (total * discount / 100);

                    return Math.round((discounted + Number.EPSILON) * 100) / 100;
                }

                let calculated = total;

                if (this.bill.vat_type === 'exclusive') {
                    calculated += this.vatAmount;
                }

                if (this.bill.tax_type === 'exclusive') {
                    calculated += this.taxAmount;
                }

                const discounted = calculated - (calculated * discount / 100);

                return Math.round((discounted + Number.EPSILON) * 100) / 100;
        }
        
    },

    mounted() {
        this.$store.dispatch("item/fetchItem")
        this.$store.dispatch("vendor/fetchVendor_without_pg")
        this.$store.dispatch("project/fetchProject")

        if (this.$route.query.grns) {

            this.bill.grns = this.$route.query.grns
                .split(',')
                .map(id => Number(id))
            this.$store.dispatch(
                "bill/fetchPrefilled_GRNS_Bill",
                this.bill.grns
            )
        }
        if (this.$route.query.po) {
            this.$store.dispatch("purchase_order/fetchPODetail", this.$route.query.po)
        }
        this.bill.bill_date = moment().format("YYYY-MM-DD");
    },

    methods: {
        validateType() {
            this.errors = {
                vat_type: '',
                tax_type: '',
                tax: '',
                vat: '',
            };

            let valid = true;

            if (!this.bill.vat_type) {
                this.errors.vat_type = 'Vat type is required.';
                valid = false;
            }
            if (!this.bill.tax_type) {
                this.errors.tax_type = 'Tax type is required.';
                valid = false;
            }
            if (!this.bill.vat) {
                this.errors.vat = 'Vat is required.';
                valid = false;
            }
            if (!this.bill.tax) {
                this.errors.tax = 'Tax is required.';
                valid = false;
            }

            if (valid) {
                this.onSubmit();
            }
        },
        vendorLabel(vendor) {
            return vendor ?.user ?.user_name || 'Unknown Vendor'
        },

        getVendor() {
            this.$store.dispatch("vendor/fetchVendorByUserId", this.bill.vendor).then(result => {
                this.bill.email = result.data.user.email
                this.bill.vendor_address = result.data.address
                this.bill.billing_address = result.data.address
            })
        },

        uploadFile(e) {
            this.bill.bill_attachment = e.target.files[0];
        },

        // updateItems(data) {
        //     if (data) {
        //         this.bill.details_in_depth = data;
        //         this.bill.details = data;
        //     }
        // },

    

        onSubmit() {
            if (this.bill.bill_date !== null) {
                this.bill.bill_date = moment(String(this.bill.bill_date)).format("YYYY-MM-DD");
            }
            if (this.bill.due_date !== null) {
                this.bill.due_date = moment(String(this.bill.due_date)).format("YYYY-MM-DD");
            }

            // this.bill.details = this.bill.details ?.length > 0 ? this.bill.details : null
            const payload = {
                ...this.bill,
                total: this.total,
                subtotal: this.subtotal
            };
            if (this.bill.details?.length>0) {
                this.$store.dispatch("bill/addBillProcurement", payload).then(response => {
                    // console.log(response)
                    if (response.code == 201) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });

                        setTimeout(() => {
                            this.$router.push('/procurement/bill/list')
                        }, 2000)

                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            } else {
                Swal.fire({
                    title: "Error!",
                    text: 'You must enter minimum 1 item',
                    icon: "error"
                });
            }
        }
    }
};
</script>
